(() => {
  'use strict';
  function normalizeDocumentHeadings() {
    const containers = document.querySelectorAll(
      '.shopify-policy__body .rte, .aq-product-details-v3__profile-body.rte'
    );
    containers.forEach((body) => body.querySelectorAll('h1').forEach((heading) => {
      const replacement = document.createElement('h2');
      [...heading.attributes].forEach((attr) => replacement.setAttribute(attr.name, attr.value));
      replacement.innerHTML = heading.innerHTML;
      heading.replaceWith(replacement);
    }));
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', normalizeDocumentHeadings, { once: true });
  } else {
    normalizeDocumentHeadings();
  }
})();
